<template>
    <div class="main">
        <div class="main-cards">
            <div v-for="currentList in listContacts" :key="currentList.id" class="card">
                <div class="title">
                    <fluent-icon icon="people" />
                    {{ currentList.name }}
                </div>
                <div class="idList">
                    {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.EDIT.ID') }} {{ currentList.id }}
                </div>
                <div class="qtdContacts">
                    <span class="green">{{ currentList.contacts_count }}</span> {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.EDIT.CONTACTS') }}
                </div>
                <div class="actions">
                    <woot-button 
                        v-tooltip="$t('CAMPAIGN_FLOW.LIST_CONTACTS.EDIT.BUTTON_TEXT')" 
                        :title="$t('CAMPAIGN_FLOW.LIST_CONTACTS.EDIT.BUTTON_TEXT')"
                        class="edit-contact" icon="edit" variant="smooth" size="small" @click="openModalEdit(currentList)"/>
                    <woot-button 
                        v-tooltip="$t('CAMPAIGN_FLOW.LIST_CONTACTS.DELETE.BUTTON_TEXT')" 
                        :title="$t('CAMPAIGN_FLOW.LIST_CONTACTS.DELETE.BUTTON_TEXT')"
                        class="delete-contact" icon="delete" variant="smooth" size="small" color-scheme="alert"
                        @click="openModalDelete(currentList)" />
                </div>
            </div>
        </div>
        <woot-delete-modal :show.sync="modalDelete" :on-close="closeModalDelete" :on-confirm="confirmDeletion"
            :title="$t('CANNED_MGMT.DELETE.CONFIRM.TITLE')" :message="$t('CANNED_MGMT.DELETE.CONFIRM.MESSAGE')"
            :message-value="deleteMessage" :confirm-text="$t('CANNED_MGMT.DELETE.CONFIRM.YES')" 
            :reject-text="$t('CANNED_MGMT.DELETE.CONFIRM.NO')" 
        />

        <modal-update-list-contacts
            v-if="modalEdit" 
            :show="modalEdit"
            :onClose="closeModalEdit"
            @submit="updateListContacts"
            :listContactSelected="selectList"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalUpdateListContacts from './ModalUpdateListContacts.vue';

export default {
    name: 'ListContactsView',
    components: { ModalUpdateListContacts },
    data() {
        return {
            modalDelete: false,
            selectList: null,
            modalEdit: false
        }
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
            currentUser: 'getCurrentUser',
            listContacts: 'campaignsContactList/getList'
        }),

        deleteMessage() {
            return ` ${this.selectList?.name}?`;
        },
    },

    methods: {
        openModalEdit(list){
            this.selectList = list;
            this.modalEdit = true
        },
        async updateListContacts(payload){
            const newList = {
                campaign_contact_list: {
                    ...payload,
                    account_id: this.accountId
                }
            }

            this.$store.dispatch('campaignsContactList/update', newList)
            .then(() => {
                this.closeModalEdit();
            });

        },
        closeModalEdit(){
            this.modalEdit = false
        },

        openModalDelete(list) {
            this.selectList = list;
            this.modalDelete = true;
        },
        closeModalDelete() {
            this.modalDelete = false;
        },
        confirmDeletion() {
            this.closeModalDelete();
            this.$store
                .dispatch('campaignsContactList/delete', this.selectList.id)
                .then(() => {
                    this.showAlert(this.$t('CAMPAIGN_FLOW.LIST_CONTACTS.DELETE.API.SUCCESS_MESSAGE'));
                })
                .catch(error => {
                    const errorMessage =
                        error?.message || this.showAlert($t('CAMPAIGN_FLOW.LIST_CONTACTS.DELETE.API.ERROR_MESSAGE'));
                    this.showAlert(errorMessage);
                });
        },
        showAlert(message) {
            bus.$emit('newToastMessage', message);
        },
    }
}



</script>

<style scoped>
.main {
    padding: 8px 20px;
    width: 100%;
}

.main-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.card {
    flex: 1 1 calc(33.33% - 1rem);
    min-width: 250px;
    max-width: 300px;
}

.title {
    font-size: 1.2rem;
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
}

.green {
    color: var(--g-20);
    font-size: 1.5rem;
}
</style>